import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "../../services/api";
import { Helmet } from "react-helmet";
import "./styles/ForgotPassword.css";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setEmail(e.target.value);
    if (error) setError("");
    if (success) setSuccess("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!email) {
      setError("Email adresi daxil edin.");
      return;
    }

    setLoading(true);

    try {
      const res = await axios.post("/account/forgot-password", {
        email: email,
      });

      setSuccess("Şifrə sıfırlama linki sizin email adresinizə göndərildi. Zəhmət olmasa inbox-u yoxlayın.");
      setEmail("");
    } catch (err) {
      const serverError = err.response?.data;
      if (typeof serverError === "string") {
        setError(serverError);
      } else {
        setError("Email göndərilmədi. Zəhmət olmasa yenidən cəhd edin.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fp-page">
      <Helmet>
        <title>Şifrə Sıfırlama – HeyatYolu</title>
        <meta name="description" content="HeyatYolu hesabınızın şifrəsini sıfırlamaq üçün email göndərin." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="fp-container">
        <div className="fp-card">
          {/* Header Section */}
          <div className="fp-header">
            <div className="fp-icon">
              <i className="fas fa-envelope-open"></i>
            </div>
            <h1 className="fp-title">Şifrəni Unutmusunuz?</h1>
            <p className="fp-subtitle">
              Narahat olmayın, onu sıfırlamağınıza kömək edəcəyik
            </p>
          </div>

          {/* Form Section */}
          <form onSubmit={handleSubmit} className="fp-form">
            <div className="fp-form-group">
              <label htmlFor="email" className="fp-form-label">
                <i className="fas fa-envelope"></i>
                Email Adresi
              </label>
              <input
                id="email"
                type="email"
                placeholder="email@example.com"
                required
                value={email}
                onChange={handleChange}
                className="fp-form-input"
                autoComplete="email"
              />
              <p className="fp-form-description">
                Hesabınızla bağlı email adresini daxil edin
              </p>
            </div>

            {/* Error Message */}
            {error && (
              <div className="fp-error-message">
                <i className="fas fa-exclamation-circle"></i>
                <span>{error}</span>
              </div>
            )}

            {/* Success Message */}
            {success && (
              <div className="fp-success-message">
                <i className="fas fa-check-circle"></i>
                <span>{success}</span>
              </div>
            )}

            {/* Submit Button */}
            <button
              type="submit"
              className="fp-button"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="fp-spinner"></span>
                  Göndərilir...
                </>
              ) : (
                <>
                  <i className="fas fa-paper-plane"></i>
                  Sıfırlama Linki Göndər
                </>
              )}
            </button>
          </form>

          {/* Back to Login Link */}
          <div className="fp-back-section">
            <p>
              Giriş səhifəsinə qayıtmaq istəyirsiniz?
            </p>
            <Link to="/giris" className="fp-back-link">
              <i className="fas fa-arrow-left"></i>
              Daxil ol
            </Link>
          </div>
        </div>

        {/* Decorative Elements */}
        <div className="fp-decoration">
          <div className="fp-decoration-circle fp-circle-1"></div>
          <div className="fp-decoration-circle fp-circle-2"></div>
          <div className="fp-decoration-circle fp-circle-3"></div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;